export const TOURNAMENT_ERROR_MESSAGES = {
  SERVER_ERROR: 'Server error occurred',
  UNAUTHORIZED: 'Unauthorized',
  USER_ID_REQUIRED: 'User ID is required',
  BAD_REQUEST: 'Bad request',
  FORBIDDEN: 'Deletion forbidden',
} as const;
